import React from "react"
import { useNavigate  } from "react-router-dom"
import aconsoftlogo from "../Img/aconsoftlogo.jpg";


export function LogoImg() {
    const navigate = useNavigate();
    const handleHomeclick=()=>{
      navigate("/");
    }
    return (
      <>      
        <img
          alt="Aconsoft Logo "
          src={aconsoftlogo}
          style={{margin:0, left: "3px",cursor:"pointer",alt:"Home" ,width:"auto",height:"22px", border: "12px solid white"}}
          onClick={handleHomeclick}
        />      
      </>
    );
  }
  